/*
 * File: \packages\lib\validate.js
 * File Created: 2022-03-31 10:33:39
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-03-31 18:20:45
 * Modified By: Li Haifeng
 */
import config from "../config.js";

const globalMxStatus = {
  self: Symbol("mx-cli-global-variable"),
  existNotSelf: Symbol("mx-cli-global-variable"),
  notExist: Symbol("mx-cli-global-variable"),
};

// 检查全局变量mx
const checkHasGlobalMx = () => {
  // 已存在自身的全局mx
  if (
    window.mx &&
    window.mx instanceof Object &&
    window.mx.identify &&
    window.mx.identify === config.identify
  ) {
    return globalMxStatus.self;
  } else if (window.mx && window.mx instanceof Object) {
    return globalMxStatus.existNotSelf;
  } else {
    return globalMxStatus.notExist;
  }
};

export default { checkHasGlobalMx, globalMxStatus };
